import React from 'react';
import PropTypes from 'prop-types';
import FilterButton from './FilterButton';
import './Filter.scss';
import './FilterDesktop.scss';

const FilterDesktop = props => (
  <section className="filter filter--desktop">
    <h3 className="filter-label">{props.filterLabel}</h3>
    <ul className="filter-items">
      {props.filters.map(item => (
        <li className="filter-item" key={`desktop-${item.type}`}>
          <FilterButton
            key={item.type}
            {...item}
            handleClick={props.handleFilterChange}
            selected={props.selected.includes(item.type)}
          />
        </li>
      ))}
    </ul>
  </section>
);

FilterDesktop.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  filterLabel: PropTypes.string.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleFilterChange: PropTypes.func.isRequired,
};

export default FilterDesktop;
